import { API } from 'aws-amplify';
//import { graphqlOperation } from 'aws-amplify';
import { listActivities } from '@/graphql/queries';
import { getSet } from '@/graphql/queries';
//import { listSets  } from '@/graphql/queries';
//import { queryByDate } from '@/graphql/queries';
import { activitiesByUserIdAndDate } from '@/graphql/queries';
import { updateActivityHistory } from '@/graphql/mutations';
import { createActivityHistory } from '@/graphql/mutations';
import { createUserScheduledSet } from '@/graphql/mutations';
import { deleteSet } from '@/graphql/mutations';
import { deleteUserScheduledSet } from '@/graphql/mutations';
import { updateUserScheduledSet } from '@/graphql/mutations';
import { createActivity } from '@/graphql/mutations';
import { listExercises } from '@/graphql/queries';
import { getSetExercises, cListSetsAndExercises}  from '@/customgraphql/customqueries';
import { listUserScheduledSets, listDefaultScheduledSets } from '@/graphql/queries';

//
//
//
//
//  CONTAINS UPDATES (MUTATIONS) AS WELL AS QUERIES
//
//
//
//
//
//

// GraphQL examples
// https://levelup.gitconnected.com/realtime-shopping-list-app-with-aws-amplify-appsync-graphql-and-vue-js-94f9d45fe9d2


// Mutation Example - need to supply the ID
// This example uses the records ID, updates duration and returns the ID
//mutation MyMutation {
//  updateActivityHistory(input: {id: "ascd", duration: 12345}) {
//    id
// }
//}


// https://www.youtube.com/watch?v=VKhLqBG7sdI
const variables = {
  limit: 1000, 
  // add filter as needed
};



const queryByDate = /* GraphQL */ `
  query QueryByDate(
    $date: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    QueryByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        set
        date
        duration
        status
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;


export default {

// DB types
// https://docs.aws.amazon.com/appsync/latest/devguide/scalars.html


// !!!!!!!!!!TEST THAT THESE ARE PINNED TO THE CURRENT USER!!!!!!!!
//
// not sure getUserSchedule, but may be becuase I created the test other user logged in with my real credentials
//
//
//


// From a UX POV, better to start the user off with an existing default set of exercises for the notifications
// The user can then amend the list to include their own choice of existing sets
// This method retrieves any User sets and then the Default Sets and combines into a single schedule of sets
// It is called in the Schedule page to display the users current schedule
//
async getUsersSchedule(scheduledHours, setList) {

  console.log("Queries::getUsersSchedule")
  let userSchedule = await this.getUserSchedule();


  // Need to calculate the day here......
  let defaultSchedule = await this.getDefaultSchedule('Monday');


  let usersFullSchedule = []
    // We have moved the default schedule into the DB, but until tested we will continue to use the Google cloud functions.....


    // For these scheduled Sets (both User and Default) we only have the set ID, we have to then find the corresponding Set to get the name
      // For each hour we push notifications [09..17]
        // Step 1. Check of the user has a custom set for this hour
        // IF FOUND
        // Step 2.  Look up the set details
        //          save the details to the list we will display to the user
        // Step 3.  ELSE we have to stitch in the default set for this hour
        //          Look up the set details
        //          save the details to the list we will display to the user      
        // Return the combined list of set for each hour for display to the user


// NEED TO ADD RESILIENCE AROUND ALL OF THIS - A USER MAY DELETE A CUSTOM SET (REPLACE WITH DEFAULT?)

      // loop around the scheduled hours list [09..17]
      scheduledHours.forEach(hour => {
      for (const key in hour) {

        const currentHour = hour[key];
      
        // Step 1 - Look for a user defined set for this houe
        let setForThisHour = userSchedule.find(entry => entry.hour === key);
        if (setForThisHour) {

          // Step 2 - User entry found, use this

          // Look up the set details
          const setDetails = setList.find(entry => entry.id === setForThisHour.set);
          if(setDetails) {
              let newEntry = { id:setForThisHour.id,  title: setDetails.title, setID: setForThisHour.set, hour: key, displayHour: currentHour, exercises: setDetails.exercises, type: 'custom' };
              usersFullSchedule.push(newEntry)
          } else {
            console.log("Error: could not find the selected set in the Set table")
          }

        } else {
            // Step 3. Use the Default set
            const setForThisHour = defaultSchedule.find(entry => entry.hour === key);

            // Look up the set details
            const setDetails = setList.find(entry => entry.id === setForThisHour.set);

            let newEntry = { id:setForThisHour.id, title: setDetails.title, setID: setForThisHour.set, hour: key, displayHour: currentHour, exercises: setDetails.exercises, type: 'default' };
            usersFullSchedule.push(newEntry)
   
        }


        }
      })

      return(usersFullSchedule)
},



async saveUserScheduledSet(customSetData) {

    try {
      await API.graphql({ 
        query: createUserScheduledSet, 
        variables: { input: customSetData },
        authMode: 'AMAZON_COGNITO_USER_POOLS'});

    } catch (err) {
      console.log("saveUserScheduledSet. Error:", err);
    }

},

async saveActivityDetails(activityData) {

    try {
      await API.graphql({ 
        query: createActivity, 
        variables: { input: activityData },
        authMode: 'AMAZON_COGNITO_USER_POOLS'});

    } catch (err) {
      console.log("saveActivityDetails. Error:", err);
    }

},


// We fetch the current value and then update.....
async updateActivityHistory (user, duration) {
  
  let today = new Date().toJSON().slice(0, 10); // "2022-06-17"

  let recordDuration=0
  let recordID=0


  // retrieve the current row - if exists
  await API.graphql({ query: activitiesByUserIdAndDate, variables: { userID: user, date: {eq: today}, limit: 1}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {
    try {
        recordDuration = response.data.activitiesByUserIdAndDate.items[0].duration
        recordID = response.data.activitiesByUserIdAndDate.items[0].id

    } catch {
      console.log("history row not found....")
    }
    
  })


  if(recordID==0) {
    

      const activityHistoryDetails = {
      userID: user,
      duration: duration,
      date: today
      };

      await API.graphql({
        query: createActivityHistory,
        variables: {input: activityHistoryDetails},
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      });

  } else {
   
    // set up the input record
    const activityHistoryDetails = {
      id: recordID,
      duration: recordDuration + duration
      }

    try {
          // Now update the duration total for today.....
        await API.graphql({ 
        query: updateActivityHistory, 
        variables: { input: activityHistoryDetails },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
    } catch(error) {
      console.log("could not update history....")
      console.log(error)
    }

  }

},

// sample call: 
//    await queries.updateScheduledSet(this.selectedCustomSet.id, this.selectedCustomSet.setID);

async deleteUserScheduledSet (id) {

    // set up the input record
    const inputRecord = {
      id: id
      }
      
    try {
        await API.graphql({ 
        query: deleteUserScheduledSet, 
        variables: { input: inputRecord },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
    } catch(error) {
      console.log("could not delete User Schedule Set....")
      console.log(error)
    }

},


async deleteSet (setID) {

    // set up the input record
    const inputRecord = {
      id: setID
      }
      
    try {
        await API.graphql({ 
        query: deleteSet, 
        variables: { input: inputRecord },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
    } catch(error) {
      console.log("could not delete Set....")
      console.log(error)
    }

},

// sample call: 
//    await queries.updateScheduledSet(this.selectedCustomSet.id, this.selectedCustomSet.setID);

async updateUserScheduledSet (id, set) {

    // set up the input record
    const inputRecord = {
      id: id,
      set: set
      }
      
    try {
          // Now update the duration total for today.....
        await API.graphql({ 
        query: updateUserScheduledSet, 
        variables: { input: inputRecord },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
    } catch(error) {
      console.log("could not update User Schedule Set....")
      console.log(error)
    }

},


  // Pinned to the current user
  async getUserSchedule () {
    let userSchedule;
    await API.graphql({
        query: listUserScheduledSets,
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          userSchedule = response.data.listUserScheduledSets.items;
      })
    
    return userSchedule
  },


  // Pinned to the current user
  async getDefaultSchedule (day) {
  
    let defaultSchedule;
    let filter = {day: {eq: day } }
    await API.graphql({
        query: listDefaultScheduledSets,
        variables: { filter: filter},
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          defaultSchedule = response.data.listDefaultScheduledSets.items;
      })
    return defaultSchedule
  },




  // Pinned to the current user
  async getActivities () {
    let activitiesList;
    await API.graphql({
        query: listActivities,
        variables: variables,
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          activitiesList = response.data.listActivities.items;
      })
      
    return activitiesList
  },

  async getExerises () {
    let exerciseList;
    await API.graphql({
        query: listExercises,
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          exerciseList = response.data.listExercises.items;
      })
      

      // convert the JSON OBJECTS
      for(let i=0;i<exerciseList.length;i++) {

          exerciseList[i].how = JSON.parse(exerciseList[i].how)

      }

    return exerciseList
  },


 async getSetExercises (id) {

    let exerciseList;
    await API.graphql({
        query: getSetExercises,
        variables: {id : id},
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          exerciseList = response.data.getSet;
  
      })

   return(exerciseList)    
  },




/* Use QueryByDate, does a proper query, rather than a scan...... */
async getActivityDurationForToday () {
  
  console.log("getActivityDurationForToday")
  let today = new Date().toJSON().slice(0, 10); // "2022-06-17"
  //console.log("Today")
  //console.log(today)

  let duration=0;
  let minutes=0;

  //console.log("The query")
  //console.log(queryByDate)


  try {
    await API.graphql({ query: queryByDate, variables: { date: today, limit: 100}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {
      console.log("response received......")
      for(let i=0;i<response.data.QueryByDate.items.length;i++) {
            duration = duration + response.data.QueryByDate.items[i].duration
        }
    })


  } catch(e) {
    console.log("getActivityDurationForToday: ERROR")
    console.log(e)
  }



  minutes = Math.floor(duration / 60);
 
  //console.log("Minutes")
  //console.log(minutes)


  // demo return(minutes)
  return(minutes);
  },


/* Use QueryByDate, does a proper query, rather than a scan...... */
async getActivitiesForToday () {
  
  let today = new Date().toJSON().slice(0, 10); // "2022-06-17"


  let activities="";

  await API.graphql({ query: queryByDate, variables: { date: today, limit: 100}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {

    activities = response.data.QueryByDate.items

    })

 
  return(activities);
  },





// We fetch the current value and then update.....
// review the duration and calculate the duration status to display in the list
async getActivitiesHistoryForUser (user) {
  
  let userActivity= ""
  let activityHistory=[];


  //console.log("activitiesByUserIdAndDate")
  //console.log(activitiesByUserIdAndDate)

  // retrieve the current row - if exists
  await API.graphql({ query: activitiesByUserIdAndDate, variables: { userID: user, limit: 50}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {
    try {
        userActivity = response.data.activitiesByUserIdAndDate.items
    } catch(err) {
      console.log("history rows not found....")
      console.log("Errors: " + err)
    }
    
    for(let i=0;i<userActivity.length;i++) {
      let activityByDay={}
      activityByDay.date=userActivity[i].date
      activityByDay.duration=userActivity[i].duration

      let durationStatus=""
      if(activityByDay.duration <300) { // 5 mins
          durationStatus='red'
      } else if (activityByDay.duration >= 300 && activityByDay.duration<600) { // and 10 mins
          durationStatus='orange'
      } else if (activityByDay.duration >= 600 && activityByDay.duration<1200) { // and 20 mins
          durationStatus='yellow'
      } else {
          durationStatus='green'
      }
      activityByDay.durationStatus=durationStatus
      activityHistory.push(activityByDay)
    }
  })


  return(activityHistory.reverse())
  },




// Return Sets + exercises for the current user and 'microcise'
async listSetExercisesForOwnerAndMicrocise (owner) {
  
  // https://docs.amplify.aws/lib/graphqlapi/query-data/q/platform/js/#filtering-queries

  //let filter =  {or: [{ subtitle: {contains:":Core"} }, { subtitle: {contains:":legs"} }]}

  let setList=[];
  let filter =  {or: [{owner: {eq: owner } }, {owner: {eq: 'microcise' } }]}
  await API.graphql({ query: cListSetsAndExercises, variables: { filter: filter}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {

      for(let i=0;i<response.data.listSets.items.length;i++) {
            // map the attributes need - in a neater hierarchy
            let set={}
            set.id=response.data.listSets.items[i].id
            set.title=response.data.listSets.items[i].title
            set.description=response.data.listSets.items[i].description
            set.sequences=response.data.listSets.items[i].sequences
            set.owner=response.data.listSets.items[i].owner
            set.setType=response.data.listSets.items[i].setType

            let exercises=[]
            for(let j=0;j<response.data.listSets.items[i].exercises.items.length;j++) {

              exercises.push(response.data.listSets.items[i].exercises.items[j].exercise)
            }
            set.exercises=exercises
            setList.push(set)

        }
    })

  return(setList);

  },



async listSetExercisesWithFilter (owner) {
  
// https://docs.amplify.aws/lib/graphqlapi/query-data/q/platform/js/#filtering-queries
  //console.log("Filter: " + filter)

  //let filter =  {or: [{ subtitle: {contains:":Core"} }, { subtitle: {contains:":legs"} }]}

  let setList=[];
  let filter = {owner: {eq: owner } }
  await API.graphql({ query: cListSetsAndExercises, variables: { filter: filter}, authMode: 'AMAZON_COGNITO_USER_POOLS'}).then((response) => {

      for(let i=0;i<response.data.listSets.items.length;i++) {
            // map the attributes need - in a neater hierarchy
            let set={}
            set.id=response.data.listSets.items[i].id
            set.title=response.data.listSets.items[i].title
            set.description=response.data.listSets.items[i].description
            set.sequences=response.data.listSets.items[i].sequences
            set.owner=response.data.listSets.items[i].owner
            set.setType=response.data.listSets.items[i].setType
            let exercises=[]
            for(let j=0;j<response.data.listSets.items[i].exercises.items.length;j++) {
              exercises.push(response.data.listSets.items[i].exercises.items[j].exercise)
            }
            set.exercises=exercises
            setList.push(set)

        }
    })

  return(setList);

  },


async getSet (id) {

    let selectedSet;

    try {
      await API.graphql({
        query: getSet,
        variables: {id : id},
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }).then((response) => {
          selectedSet = response.data.getSet;

      })
    } catch(err) {
      console.log("Queries::getSet Errors: " + err)
    }


    return(selectedSet)
   
  },



/*



methods: {
    async getList() {
        // Get all shopping list items to display on page load
        const { data } = await API.graphql(
          graphqlOperation(queries.listShoppingListItems)
        );
        data.listShoppingListItems.items.forEach(item => {
          this.listItems.push(item);
        });
      },


    // call our graph mutation to add a new shopping list item
    async addShoppingItem() {
      await API.graphql(
        graphqlOperation(mutations.createShoppingListItem, {
          input: { itemName: this.newItem }
        })
      );
      //clear textbox
      this.newItem = "";
    },
    // call our graph mutation to add a new shopping list item
    deleteShoppingItem(itemId) {
      API.graphql(
        graphqlOperation(mutations.deleteShoppingListItem, {
          input: { id: itemId }
        })
      );
    }
  }


*/



}